{
  "title": "AirPlx",
  "message": "Wir führen gerade geplante Wartungsarbeiten durch. AirPlx wird voraussichtlich um {{endTime}} wieder online sein."
}
